import React from 'react';
import styled from 'styled-components';
import { FieldError, FieldValues, UseFormRegister } from 'react-hook-form';

import { media, sizing } from '@/styles/theme';

interface IFormCheckboxGroup {
  label?: string;
  name: string;
  required?: boolean;
  register?: UseFormRegister<FieldValues>;
  radios: {
    name: string;
    label: string;
    value: string;
    checked?: boolean;
  }[];
  error?: FieldError;
  className?: string;
  type?: 'radio';
  handleChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  value?: string | number;
  isCheckedHandledByComponent?: boolean;
}

const RadioGroup = (props: IFormCheckboxGroup): React.ReactElement => {
  const { label, radios, className, error, register, name, required, value, isCheckedHandledByComponent } = props;
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (props.handleChange) {
      props.handleChange(e);
    }
  };

  const registerData = !isCheckedHandledByComponent ? register && register(name, { required: required }) : {};

  return (
    <Fieldset className={className}>
      <InputContainer>
        {label && <InputLabel className="group-label">{label}</InputLabel>}
        <RadioContainer>
          {radios.map(radio => (
            <span className="radio-wrapper" key={`${radio.name}-${radio.value}`}>
              <input
                className="radio-item"
                id={`${radio.name}-${radio.value}`}
                name={radio.name}
                value={radio.value}
                type={'radio'}
                onChange={handleChange}
                checked={isCheckedHandledByComponent ? value === radio.value : radio.checked}
                {...registerData}
              />
              {radio.label && <label htmlFor={`${radio.name}-${radio.value}`}>{radio.label}</label>}
            </span>
          ))}
        </RadioContainer>
      </InputContainer>
      {error && <ErrorMessage className="error-message">{error}</ErrorMessage>}
    </Fieldset>
  );
};

export { RadioGroup };

const Fieldset = styled.fieldset`
  font-size: ${sizing.fontSize.sm};
`;

const InputLabel = styled.label`
  font-size: 15px;
  font-weight: 600;
  color: #374151;
  line-height: 24px;
  margin: 0;
  min-width: 140px;
`;

const InputContainer = styled.div`
  display: flex;
  gap: 30px;
  flex-wrap: wrap;
  align-items: center;
`;

const RadioContainer = styled.div`
  display: flex;
  gap: 10px;
  ${media.tablet} {
    gap: 30px;
  }

  .radio-wrapper {
    display: flex;
    align-items: center;
  }
  input[type='radio']:checked + label {
    color: #243342;
    font-weight: 700;
  }
  input[type='radio'] {
    margin-right: 5px;
    width: 16px;
    height: 16px;
  }

  label {
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
    color: #5b6671;
    margin-bottom: 0;
  }
`;

const ErrorMessage = styled.div`
  font-size: 12px;
  line-height: 12px;
  height: 24px;
  padding-top: 4px;
  color: #dc3545;
`;
